$('.team-item__hover').on('mouseenter', function() {
    $(this).css('backgroundSize', '0px, cover');
});

$('.team-item__hover').on('mouseleave', function() {
    $(this).css('backgroundSize', 'cover, 0px');
});
